import { render, staticRenderFns } from "./SapDeliveryLogisticsRecord.vue?vue&type=template&id=242e610e&scoped=true&"
import script from "./SapDeliveryLogisticsRecord.vue?vue&type=script&lang=js&"
export * from "./SapDeliveryLogisticsRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242e610e",
  null
  
)

export default component.exports